import React from 'react';
import { CircleCheck } from 'lucide-react';
import * as S from './styled';

export const columns = [
    {
        title: 'Loja',
        dataIndex: 'name',
        key: 'id',
    },
    {
        title: 'Status',
        dataIndex: 'hasPlanogram',
        key: 'hasPlanogram',
        width: 250,
        render: (hasPlanogram: boolean) => {
            const statusRandom = hasPlanogram;

            return (
                <S.StatusPlanogram status={statusRandom}>
                    {statusRandom && <CircleCheck size={12} />}
                    {statusRandom ? 'Produto já existente' : 'Produto ausente'}
                </S.StatusPlanogram>
            );
        },
    },
];
